// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2jlmg","title":"AfterFrontImage_title__1J2xu"};